import React, { useRef, useState } from "react";
import countryDenominations from "./countryDenominations";
import InputKeyboard from "./InputKeyboard";
import { getObjectValue } from "@utility/utills";
import { LABEL } from "../../veriables";
import { orderBy } from "lodash";
import { APP_CONFIG } from "@constants";
import cn from "classnames";
import styles from "./index.module.scss";
import ModalHeader from "@components/common/ModalHeader/index";
import { TouchableButton } from "../common/Touchable/index";
import PropTypes from 'prop-types';
import { safeJsonParse } from "../../utility/helperFunction";
const CounterCash = (props) => {
  // Props Destructuring
  const {
    onSubmit,
    amount = "",
    list = {},
    isCashIn,
    cashInData,
    isDrawerOpen,
  } = props;

  // State Management
  const authKey = safeJsonParse(window.sessionStorage.getItem("auth"), {});
  const countryCode = authKey?.countryCode ?? 1;
  const serverAppTheme = authKey?.serverAppTheme ?? null;
  const isLandScape = !props.orderingPortraitOrientation;
  const inputKeyboardRef = useRef(null);
  const [selectedInput, setSelectedInput] = useState("");
  const [totalAmount, setTotalAmount] = useState(() => amount);

  // Methods
  const getCashReturnList = () => {
    const { higherUnit, conversionUnit, lowerUnit } =
      countryDenominations[countryCode];
    const cashList = {};
    let List = {};
    higherUnit.currencyList.forEach((unit) => {
      List[unit] = {
        symbol: higherUnit.symbol,
        type: higherUnit.type,
        conversionUnit,
        index: 0,
        length: 0,
        unit,
        computedValue: 0,
        cummulativeUnit: unit,
        displayValue: `${higherUnit.symbol}${unit}`,
      };
      cashList[higherUnit.type] = {
        type: higherUnit.type,
        list: List,
      };
    });
    List = {};
    lowerUnit.currencyList.forEach((unit) => {
      const Unit = unit === conversionUnit ? unit / conversionUnit : unit;
      List[unit] = {
        symbol: unit === conversionUnit ? higherUnit.symbol : lowerUnit.symbol,
        type: lowerUnit.type,
        conversionUnit,
        index: 1,
        length: 0,
        unit,
        computedValue: 0,
        cummulativeUnit: unit / conversionUnit,
        displayValue:
          unit === conversionUnit
            ? `${higherUnit.symbol}${Unit}`
            : `${Unit}${lowerUnit.symbol}`,
      };
      cashList[lowerUnit.type] = {
        type: lowerUnit.type,
        list: List,
      };
    });
    return { result: cashList, totalAmt: 0 };
  };
  const [groupedList, setGroupedList] = useState(() => {
    if (Object.keys(list).length > 0) {
      return list;
    }
    const { result } = getCashReturnList();
    return result;
  });
  const handleBlur = (string) => {
    setSelectedInput(string);
    const [type, unit] = string.split("-");
    inputKeyboardRef.current.openKeyboard();
    const keyboardValue = groupedList[type]?.list[unit]?.length;
    inputKeyboardRef.current.setKeyboardValue(String(keyboardValue));
    const elements = document.querySelectorAll("#count");
    elements.forEach((element) => {
      element.blur();
    });
  };

  const handleAmountBlur = (string) => {
    const element = document.querySelector(`#${string}`);
    element.blur();
  };

  const updateGroupList = (length) => {
    const [type, unit] = selectedInput.split("-");
    const computedValue = +(
      groupedList[type].list[unit].cummulativeUnit * length
    );
    groupedList[type].list[unit] = {
      ...groupedList[type].list[unit],
      length,
      computedValue,
    };
    let total = 0;
    Object.values({ ...groupedList } || {}).forEach(({ list }) => {
      Object.values(list)?.forEach(({ computedValue }) => {
        total += computedValue;
      });
    });
    setTotalAmount(total);
    setGroupedList({ ...groupedList });
  };

  // HTML CSS CODE
  return (
    <>
      <ModalHeader tileHeader="Cash Register" />

      <div className={cn(isLandScape? 'col-12 h-50':'h-38 px-12', "d-flex pt-2 mb-12")}>
        {/* bill */}
        <div className="col-6 pr-2 pl-0">
          <div
            className="col-12 pt-1 pb-2 px-12 h-100 rounded"
            style={{ border: "1px solid #9F9F9F" }}
          >
            {Object.values(groupedList)
              ?.filter((e) => e.type === "Bill")
              ?.map(({ type, list }, i) => {
                return (
                  <div 
                  key={i}
                    className={cn("h-100")}
                  >
                    <div className="fs_16 fw-600 pb-1 text-center w-100">
                      {type}
                    </div>
                    <div className="h-90">
                      {Object.values(orderBy(list, ["unit"], ["desc"]))?.map(
                        (
                          { length, displayValue, computedValue, unit },
                          index,
                          arr,
                        ) => {
                          const isLastItem = index === arr.length - 1;
                          return (
                            <div
                              key={unit}
                              className={cn(
                                "col-12 d-flex p-0",
                                isLastItem ? "" : isLandScape? "mb-12": 'mb-15',
                              )}
                              style={{
                                height: "32px",
                              }}
                            >
                              <div
                                className={cn(
                                  isLandScape? "col-3 p-0": `${styles.widthBox}`,
                                  // selectedInput === `${type}-${unit}`
                                  //   ? "od-container-card-border border-color-primary"
                                  //   : "",
                                )}
                              >
                                <input
                                  id="count"
                                  type="number"
                                  onFocus={() => handleBlur(`${type}-${unit}`)}
                                  className="h-100 p-1 text-center w-100 rounded"
                                  style={{ border: "1px solid #D1D5DC" }}
                                  value={Number(length)}
                                />
                              </div>

                              <div className={cn(isLandScape? "col-4 px-12":'col px-2',"align-items-center d-flex")}>{`x ${displayValue}`}</div>

                              <div className={cn(isLandScape? "col-5 p-0":'col px-0',"d-flex align-items-center justify-content-end")}>
                                {computedValue == 0 ? 0.0 : computedValue}
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        {/* coin */}
        <div className={cn('col-6 pl-2 pr-0')}>
          <div
            className="col-12 pt-1 pb-2 px-12 h-100 rounded"
            style={{ border: "1px solid #9F9F9F" }}
          >
            {Object.values(groupedList)
              ?.filter((e) => e.type === "Coin")
              ?.map(({ type, list }, i) => {
                return (
                  <div 
                  key={i}
                    className={cn("h-100")}
                  >
                    <div className="fs_16 fw-600 pb-1 text-center w-100">
                      {type}
                    </div>
                    <div className="h-90">
                      {Object.values(orderBy(list, ["unit"], ["desc"]))?.map(
                        (
                          { length, displayValue, computedValue, unit },
                          index,
                          arr,
                        ) => {
                          const isLastItem = index === arr.length - 1;
                          return (
                            <div
                              key={unit}
                              className={cn(
                                "col-12 d-flex p-0",
                                isLastItem ? "" : isLandScape? "mb-1": 'mb-12',
                              )}
                              style={{
                                height: "32px",
                              }}
                            >
                              <div
                                className={cn(
                                  isLandScape? "col-3 p-0": `${styles.widthBox}`,
                                  // selectedInput === `${type}-${unit}`
                                  //   ? "od-container-card-border border-color-primary"
                                  //   : "",
                                )}
                              >
                                <input
                                  id="count"
                                  type="number"
                                  onFocus={() => handleBlur(`${type}-${unit}`)}
                                  className="h-100 p-1 text-center w-100 rounded"
                                  style={{ border: "1px solid #D1D5DC" }}
                                  value={Number(length)}
                                />
                              </div>

                              <div className={cn(isLandScape? "col-4 px-12":'col px-2',"align-items-center d-flex")}>{`x ${displayValue}`}</div>

                              <div className={cn(isLandScape? "col-5 p-0":'col p-0',"d-flex align-items-center justify-content-end")}>
                                {computedValue == 0 ? 0.0 : computedValue}
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      <div className={cn(isLandScape? "col-12 d-flex h-40" : 'h-100')}>
        {/* keyboard */}
        <div className={cn(isLandScape? "col-6 pr-2 pl-0" : `col-12 h-29 ${styles.marginTop}`)}>
          <InputKeyboard
            ref={inputKeyboardRef}
            name="Inputkeyboard"
            onChange={(val) => {
              if (!selectedInput) {
                return "";
              }
              updateGroupList(val);
            }}
            selectedInput={selectedInput}
            amount={totalAmount}
            btnStyle={isLandScape? 'cashOutLandScape' : 'cashOutPotrait'}
          />
        </div>

        {/* subtotal and buttons*/}
        <div className={cn(isLandScape? "col-6 pl-2 pr-0" : 'col-12')}>
          {isCashIn ? (
            <div className="h-100">
              <div className={cn(isLandScape? 'pb-3':'pb-20',"d-flex justify-content-between")}>
                <div className="fs_18 fw-500" style={{ color: "#787878" }}>
                  {LABEL().CURRENT_BALANCE}
                </div>
                <div>
                  <input
                    id="currentBalance"
                    type="number"
                    onFocus={() => handleAmountBlur("currentBalance")}
                    className="border-0 text-right fs_18 fw-400"
                    style={{
                      background: "none",
                    }}
                    value={Number(cashInData?.balance ?? 0)?.toFixed(2)}
                  />
                </div>
              </div>
              <div className={cn(isLandScape? 'pb-3':'pb-20',"d-flex justify-content-between")}>
                <div className="fs_18 fw-500" style={{ color: "#787878" }}>
                  {LABEL().PENDING_BALANCE}
                </div>
                <div>
                  <input
                    id="pendingBalance"
                    type="number"
                    onFocus={() => handleAmountBlur("pendingBalance")}
                    className="border-0 text-right fs_18 fw-400"
                    style={{
                      background: "none",
                    }}
                    value={Number(cashInData?.pendingBalance ?? 0)?.toFixed(2)}
                  />
                </div>
              </div>
              <div className={cn(isLandScape? 'pb-3':'pb-20', "d-flex justify-content-between")}>
                <div className="fs_18 fw-500" style={{ color: "#787878" }}>
                  {LABEL().AMOUNT_ENTERED}
                </div>
                <div>
                  <input
                    id="amountEntered"
                    type="number"
                    onFocus={() => handleAmountBlur("amountEntered")}
                    className={cn(isLandScape? ' fw-400':' fw-600', "border-0 text-right fs_18")}
                    style={{
                      background: "none",
                    }}
                    value={Number(totalAmount ?? 0)?.toFixed(2)}
                  />
                </div>
              </div>

              {/* buttons */}
              <div className={cn(isLandScape? 'h-34': 'h-100', "col-12 d-flex p-0")}>
                <div className={cn("col-6 text-center pl-0 h-100")}>
                  <TouchableButton
                    className={cn(
                      "btn-ripple w-100 fs_24 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color fw-600",
                    )}
                    style={{
                      borderRadius: "4px",
                      border: "1px solid #2541A4",
                      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                      color: serverAppTheme?.primary_text,
                      height:  isLandScape? '100%' : '68px',
                    }}
                    type="button"
                    onClick={(e) => {
                      props.navigate(
                        `${APP_CONFIG.BASE_URL}/serverApp/checks`,
                        { replace: true },
                      );
                      e.preventDefault();
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().CASH_IN_CANCEL}
                  </TouchableButton>
                </div>

                <div className={cn("col-6 text-center p-0 h-100")}>
                  <TouchableButton
                    className={cn(
                      "btn-ripple shadow-none border-0 w-100 fs_24 od-primary-btn-bg-color od-primary-btn-font-color fw-600",
                    )}
                    style={{
                      borderRadius: "4px",
                      background: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      height:  isLandScape? '100%' : '68px',
                    }}
                    type="button"
                    onClick={(e) => {
                      onSubmit({ amount: totalAmount, list: groupedList });
                      e.preventDefault();
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().CASH_IN}
                  </TouchableButton>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-30 h-100 text-primary od-text-primary">
              <div className="h-25 p-1" />
              <div className="h-25 p-1">
                <div
                  className={cn(
                    "w-100 rounded d-flex align-items-center btn justify-content-center",
                    isDrawerOpen
                      ? "bg-green color-white"
                      : "bg-red color-white",
                  )}
                >
                  {isDrawerOpen ? LABEL().DRAWER_OPEN : LABEL().DRAWER_CLOSE}
                </div>
              </div>
              <div className="h-25 d-flex p-1">
                <div className="w-50 py-2">{LABEL().AMOUNT_ENTERED}</div>
                <div className={cn(styles.input, "w-50")}>
                  <input
                    id="amountEntered"
                    type="number"
                    onFocus={() => handleAmountBlur("amountEntered")}
                    className="w-100 form-control p-1"
                    value={Number(totalAmount ?? 0)?.toFixed(2)}
                    disabled
                  />
                </div>
              </div>
              <div
                role="presentation"
                onClick={() =>
                  onSubmit({ amount: totalAmount, list: groupedList })
                }
                className={cn("p-1 h-25 text-center w-100")}
              >
                <div className="rounded od-btn-primary btn-primary btn-ripple btn35">
                  {LABEL().CASH_OUT}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

CounterCash.propTypes = {
  onSubmit: PropTypes.func,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  list: PropTypes.object,
  isCashIn: PropTypes.bool,
  isDrawerOpen: PropTypes.bool,
  navigate: PropTypes.func,
  cashInData: PropTypes.shape({
    balance: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    pendingBalance: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }),
};


CounterCash.defaultProps = {
  onSubmit: () => {},
  amount: "",
  list: {},
  isCashIn: false,
  isDrawerOpen: false,
  navigate: () => {},
  cashInData: {
    balance: 0,
    pendingBalance: 0,
  },
};


export default CounterCash;
